import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import LayoutHeader from '../../../../layout/LayoutHeader';
import RedirectForMusic from '../../../../components/Focuspage/Type/Music/RedirectForMusic';
import { useDispatch } from 'react-redux';
import { clearFocusSection } from '../../../../store/focuspage/focuspageSlice';

export default function SelectMusicType() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(clearFocusSection())
    }, [dispatch])
    return (
        <LayoutHeader>
            <div className="w-[390px] h-[80vh] flex flex-col justify-start items-center relative z-[0]">
                <div className='px-4 my-[50px] flex w-full justify-between'>
                    <p className='text-white'>Select music page type</p>
                    <button onClick={() => navigate('/focus-page/focus-type')} className='text-white cursor-pointer'>Go back</button>
                </div>
                <RedirectForMusic txt="Single" link="/focus-page/music-type/step1" type="single" />
                <RedirectForMusic txt="Multiple" dotimgclss={false} link="/focus-page/music-type/step1" type="multiple" />
                <div className="w-full px-4 absolute bottom-[27px] left-0">
                    <div className="text-[12px] text-[rgba(255,255,255,0.5)] leading-[1.5] max-w-full">
                        <p>Choose between a single track or multiple tracks layout.</p>
                        <p>Single is perfect for one release, while multiple lets you showcase your entire discography.</p>
                    </div>
                </div>
            </div>
        </LayoutHeader>
    );
}
